import {useHistory} from "react-router-dom";
import React, { useState, useEffect } from 'react';

function SettingsPage() {
    const history = useHistory();
    const [retailCrmAddress, setRetailCrmAddress] = useState(localStorage.getItem("retailCrmAddress") || '');
    const [retailCrmKey, setRetailCrmKey] = useState(localStorage.getItem("retailCrmKey") || '');

    useEffect(() => {
        localStorage.setItem('retailCrmAddress', retailCrmAddress);
        localStorage.setItem('retailCrmKey', retailCrmKey);
    }, [retailCrmAddress, retailCrmKey]);

    useEffect(function () {
        setTimeout(function () {
            BX24.fitWindow();
        }, 500)
    }, []);

    function handleNextClick() {
        history.push("/loading");
        return true;
    }

    function onChangeRetailCrmAddress() {
        setRetailCrmAddress(event.target.value)
    }
    function onChangeRetailCrmKey() {
        setRetailCrmKey(event.target.value)
    }

    return (
        <div className="SettingsPage">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="title">
                            Введите данные для начала импорта данных
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="form">
                            <form>
                                <div className="form-row">
                                    <label>Адрес RetailCRM</label>
                                    <input name="retailcrm-address" required="required" value={retailCrmAddress} onChange={onChangeRetailCrmAddress} placeholder="https://yoursite.retailcrm.ru/" />
                                </div>
                                <div className="form-row">
                                    <label>Ключ RetailCRM</label>
                                    <input name="retailcrm-key" required="required"  value={retailCrmKey} onChange={onChangeRetailCrmKey} placeholder="AAAAAAAAAAAAAAAAAAAAA11111111111" />
                                </div>
                            </form>

                            <a href="#" className="button" onClick={handleNextClick}>
                                Начать импорт
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2 offset-10 text-right">
                        <div className="paging">
                            3 / 5
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SettingsPage;
